import {
  Directive,
  Input,
  Output,
  TemplateRef,
  ViewContainerRef,
  OnInit,
  OnDestroy,
  EventEmitter,
  Renderer2,
  ElementRef
} from '@angular/core';

import { AppConfigurationService } from '../services/ipc-app-configuration.service';
import { IAppConfiguration } from '../models';

@Directive({
  selector: '[ipcAppConfiguration]',
})
export class AppConfigurationDirective implements OnInit, OnDestroy {

  @Input() public ipcAppConfiguration: string | string[];
  @Input() public ipcAppConfigurationMatchAny: boolean;
  @Input() public ipcAppConfigurationElse: TemplateRef<any> | null;
  // futureproofing this variable name https://github.com/angular/angular/issues/12121
  @Output() public ipcAppConfigurationOptions: EventEmitter<any>;

  private configurationsLoaded: any;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private appConfigurationService: AppConfigurationService,
    private renderer: Renderer2,
    private elementRef: ElementRef,
  ) {
// tslint:disable-next-line: triple-equals
    if (this.ipcAppConfigurationMatchAny == undefined) {
      this.ipcAppConfigurationMatchAny = false;
    }

    this.ipcAppConfigurationOptions = new EventEmitter<any>();
  }

  public ngOnInit(): void {
    this.configurationsLoaded = this.appConfigurationService.configurationsLoaded.subscribe((isLoaded$: boolean) => {
      if (isLoaded$) {
        if (Array.isArray(this.ipcAppConfiguration)) {
          this.renderConfigurations(this.ipcAppConfiguration);
        } else {
          this.renderConfiguration(this.ipcAppConfiguration);
        }
      }
    });

  }

  public ngOnDestroy(): void {
    this.configurationsLoaded.unsubscribe();
  }

  private createView(featureName: string | string[], isElse: boolean = false): void {
    const separator: string = this.ipcAppConfigurationMatchAny ? ' || ' : ' && ';
    const name: string =`${isElse ? 'NOT ' : ''}${Array.isArray(featureName) ? featureName.join(separator) : featureName}`;

    let templateRef: TemplateRef<any> = !isElse ? this.templateRef : this.ipcAppConfigurationElse;

    try {
      this.viewContainer.createEmbeddedView(templateRef);
      const element: HTMLElement = this.elementRef && this.elementRef.nativeElement;
      if (element.nextElementSibling) {
        this.renderer.setAttribute(element.nextElementSibling, 'data-configuration', name);
      }
    } catch (ex) {
      console.error(ex);
    }
  }

  private renderConfiguration(configurationName: string): void {
    if (this.appConfigurationService.isEnabled(configurationName)) {
        const configuration: IAppConfiguration | undefined = this.appConfigurationService.getConfiguration(configurationName);
        const options: any = configuration && configuration.options;
        this.ipcAppConfigurationOptions.emit(options);
        this.createView(configurationName);
    } else {
      this.viewContainer?.clear();
      if (this.ipcAppConfigurationElse) {
        this.viewContainer.createEmbeddedView(this.ipcAppConfigurationElse);
      }
    }
  }

  private renderConfigurations(configurations: string[]): void {
    const enabledConfigurations: boolean[] = [];
    const enabledConfigurationsArray: string[] = [];
// tslint:disable-next-line: no-inferrable-types
    let isEnabled: boolean = false;

    for (const configurationName of configurations) {
      enabledConfigurations.push(this.appConfigurationService.isEnabled(configurationName));
      enabledConfigurationsArray.push(configurationName);
    }

    if (this.ipcAppConfigurationMatchAny) {
      isEnabled = enabledConfigurations.some((x: boolean) => x === true);
    } else {
      isEnabled = enabledConfigurations.every((x: boolean) => x === true);
    }

    if (isEnabled) {
      const options: any[] = [];
      for (const configurationName of configurations) {
        const feature: IAppConfiguration | undefined = this.appConfigurationService.getConfiguration(configurationName);
        options.push(feature && feature.options);
      }

      this.ipcAppConfigurationOptions.emit(options);
      this.createView(enabledConfigurationsArray);

    } else {
      this.viewContainer?.clear();
    }
  }

}
